// TODO: check placement => is this really really shared? Or only BAB / only EC?

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, {
  Pagination
} from 'swiper/core'

import 'swiper/swiper.min.css'
import 'swiper/components/pagination/pagination.min.css'

import TabInfo from '../TabInfo'
import TrustpilotProductReviewsMultiSourceSEOWidget from '../TrustpilotProductReviewsMultiSourceSEOWidget'
import TrustpilotProductMiniWidget from '../TrustpilotProductMiniWidget'

import './styles.scss'

const DiapersPantsModalContent = ({ product, type }) => {
  const { t } = useTranslation()
  const reviewsListScrollRef = React.useRef(null)
  const reviewsListLoaderRef = React.useRef(null)

  SwiperCore.use([Pagination])

  const pagination = {
    clickable: true
  }

  const sku = {
    diapers: 'JOONECHARGE.BUNDLE.C.V1',
    pants: 'JOONECHARGE.BUNDLE.CC.V1',
    mix: 'JOONECHARGE.BUNDLE.CC.C.V1'
  }

  return (
    <div className='diapers-pants-modal-container'>
      <img src={product.img || product.img_modal} alt='' />

      <div className='diapers-pants-modal-content'>
        <h1 dangerouslySetInnerHTML={{ __html: product.title }} />

        <TrustpilotProductMiniWidget
          sku={sku[type]}
          reviewsListScrollRef={reviewsListScrollRef}
        />

        {type !== 'mix' &&
          <>
            <p>{t('diapersPantsModal:text1')}</p>
            <iframe src='https://www.youtube.com/embed/PnmoJYiv1ck' title='Joone Video' frameBorder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowFullScreen />
          </>}

        {type === 'mix' &&
          <p className='italic modal-description' dangerouslySetInnerHTML={{ __html: product.description }} />}

        <p>{product.text1}</p>
        <p>{product.text2}</p>

        {type !== 'mix' &&
          <>
            <div dangerouslySetInnerHTML={{ __html: t('diapersPantsModal:inDiaper') }} className='diapers-pants-subtitle' />
            <img src={product.compositionImg} alt='' />
            <div dangerouslySetInnerHTML={{ __html: t('diapersPantsModal:notInDiaper') }} className='diapers-pants-subtitle' />
            <p dangerouslySetInnerHTML={{ __html: product.text3 }} />

            <div className='composition-tabs'>
              {product?.composition && Object.values(product.composition).map((composition, i) =>
                <TabInfo tab={composition.title} product={composition.content} key={i} />
              )}
            </div>

            <div dangerouslySetInnerHTML={{ __html: t('diapersPantsModal:certifications') }} className='diapers-pants-subtitle' />

            <Swiper slidesPerView={1} pagination={pagination}>
              {product?.certifications && Object.values(product.certifications).map((certification, i) =>
                <SwiperSlide key={i}>
                  <div className='certification-slide'>
                    <img src={certification.img} alt='' />
                    <p dangerouslySetInnerHTML={{ __html: certification.content }} />
                  </div>
                </SwiperSlide>
              )}
            </Swiper>
          </>}
      </div>

      <p className='engagement-sub-text'>{product?.engagement_sub_text}</p>

      <div className='doorz'>
        <div className='doorz-title'>{t('diapersPantsModal:doorz')}</div>
        <iframe src='https://www.youtube.com/embed/hKWqQPKXXhw' title='Doorz video' frameBorder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowFullScreen />
        <p dangerouslySetInnerHTML={{ __html: t('diapersPantsModal:doorzText') }} />
      </div>

      <div ref={reviewsListScrollRef}>
        {sku && <TrustpilotProductReviewsMultiSourceSEOWidget sku={sku[type]} reference={reviewsListLoaderRef} />}
      </div>
    </div>
  )
}

export default DiapersPantsModalContent
